import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthModule } from '@bidi/common-services';
import { AvatarSelectorComponent } from './avatar-selector/avatar-selector.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { ProfileComponent } from './profile.component';
import { AchievementsComponent } from './achievements/achievements.component';
import { UserFileComponent } from './user-file/user-file.component';

@NgModule({
  imports: [
    CommonModule,
    AuthModule
  ],
  declarations: [
    ProfileComponent,
    AvatarSelectorComponent,
    ConfigurationComponent,
    AchievementsComponent,
    UserFileComponent
  ],
  exports: [
    ProfileComponent,
    AvatarSelectorComponent,
    ConfigurationComponent
  ]
})
export class ProfileModule {
}
